export default {
    catName: "fod",
    options: {
        showCatTabs: true
    },
    sucategories: [
        {
            id: "vodka",
            name_ro: "BAUTURI SPIRTOASE / SPIRITS ",
            desc_ro: "VODKA",
            subcategorie: "VODKA",
            name_eng: "",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "ERISTOFF",
                    desc_ro: "37.5% alc.",
                    gramaj: "40 ml",
                    price: 8,
                },
                {
                    name_ro: "FINLANDIA",
                    desc_ro: "40% alc.",
                    gramaj: "40 ml",
                    price: 9,
                },
                {
                    name_ro: "GREY GOOSE",
                    desc_ro: "40% alc.",
                    gramaj: "40 ml",
                    price: 30,
                },
            ]
        },
        {
            id: "whisky",
            name_ro: "BLENDED WHISKY STANDARD",
            desc_ro: "",
            name_eng: "",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "WILLIAM LAWSON'S ",
                    desc_ro: "40% alc.",
                    gramaj: "40 ml",
                    price: 8,
                },
                {
                    name_ro: "THE FAMOUS GROUSE ",
                    desc_ro: "40% alc.",
                    gramaj: "40 ml",
                    price: 10,
                },
                {
                    name_ro: "DEWAR'S ",
                    desc_ro: "White Label 40% alc.",
                    gramaj: "40 ml",
                    price: 10,
                },
            ]
        },
        {
            id: "whisky",
            name_ro: "BLENDED WHISKY 12 Y.O. ",
            desc_ro: "",
            subcategorie: "BLENDED WHISKY 12 Y.O. ",
            name_eng: "",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "DEWAR'S ",
                    desc_ro: "12 Y.O. 40% alc. ",
                    gramaj: "40 ml",
                    price: 18,
                },
                {
                    name_ro: "JOHNNIE WALKER ",
                    desc_ro: "Black Label 40% alc. ",
                    gramaj: "40 ml",
                    price: 24,
                },
                {
                    name_ro: "CHIVAS REGAL",
                    desc_ro: "12 Y.O. 40% alc. ",
                    gramaj: "40 ml",
                    price: 30,
                },
            ]
        },
        {
            id: "whisky",
            name_ro: "SINGLE MALT WHISKY",
            desc_ro: "",
            subcategorie: "SINGLE MALT WHISKY ",
            name_eng: "",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "THE MACALLAN ",
                    desc_ro: "Amber 40% alc. ",
                    gramaj: "40 ml",
                    price: 33,
                },
                {
                    name_ro: "HIGHLAND PARK ",
                    desc_ro: "12 Y.O. 40% alc.",
                    gramaj: "40 ml",
                    price: 30,
                },
                {
                    name_ro: "ABERFELDY ",
                    desc_ro: "12 Y.O. 40% alc. ",
                    gramaj: "40 ml",
                    price: 32,
                },
            ]
        },
        {
            id: "whisky",
            name_ro: "AMERICAN WHISKEY",
            desc_ro: "",
            subcategorie: "AMERICAN WHISKEY ",
            name_eng: "",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "JACK DANIEL'S ",
                    desc_ro: "Old No.7 40% alc. ",
                    gramaj: "40 ml",
                    price: 15,
                },
                {
                    name_ro: "JACK DANIEL'S ",
                    desc_ro: "Single Barrel 45% alc. ",
                    gramaj: "40 ml",
                    price: 30,
                },
                {
                    name_ro: "GENTLEMAN JACK ",
                    desc_ro: "40% alc. ",
                    gramaj: "40 ml",
                    price: 25,
                },
                {
                    name_ro: "WOODFORD RESERVE ",
                    desc_ro: "43.2% alc.",
                    gramaj: "40 ml",
                    price: 30,
                },
            ]
        },
        {
            id: "coniac si brandy",
            name_ro: "COGNAC & BRANDY",
            desc_ro: "",
            name_eng: "",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "REMY MARTIN",
                    desc_ro: "VSOP 40% alc. ",
                    gramaj: "40 ml",
                    price: 30,
                },
                {
                    name_ro: "REMY MARTIN",
                    desc_ro: "Coeur de Cognac 40% alc. ",
                    gramaj: "40 ml",
                    price: 50,
                },
                {
                    name_ro: "REMY MARTIN ",
                    desc_ro: "XO Excellence 40% alc. ",
                    gramaj: "40 ml",
                    price: 100,
                },
                {
                    name_ro: "JIDVEI",
                    desc_ro: "Vinars ",
                    gramaj: "40 ml",
                    price: 10,
                },
                {
                    name_ro: "Vinars",
                    desc_ro: "38% alc.",
                    gramaj: "40 ml",
                    price: 10,
                },
                {
                    name_ro: "METAXA 7*",
                    desc_ro: "40% alc. ",
                    gramaj: "40 ml",
                    price: 15,
                },
                {
                    name_ro: "METAXA 12*",
                    desc_ro: "40",
                    gramaj: "40 ml",
                    price: 25,
                },
                {
                    name_ro: "BRANCOVEANU",
                    desc_ro: "XO Vinars 40% alc.",
                    gramaj: "40 ml",
                    price: 20,
                },
            ]
        },
        {
            id: "spirtoase limpezi",
            name_ro: "SPIRTOASE LIMPEZI",
            desc_ro: "",
            name_eng: "WHITE SPIRITS",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "DOM’ PROFESOR",
                    desc_ro: "Palinca 50% alc. ",
                    gramaj: "40 ml",
                    price: 20,
                },
                {
                    name_ro: "BOMBAY SAPPHIRE",
                    desc_ro: "Gin 40% alc.",
                    gramaj: "40 ml",
                    price: 40,
                },
                {
                    name_ro: "BRAN",
                    desc_ro: "Tuica de Prune 40% alc.",
                    gramaj: "40 ml",
                    price: 12,
                },
                {
                    name_ro: "BRAN",
                    desc_ro: "Tuica de Prune / Mere 50% alc. ",
                    gramaj: "40 ml",
                    price: 12,
                },
                {
                    name_ro: "BRAN",
                    desc_ro: "Palinca de Pere / Gutui / Caise / Afine / Capsuni / Visine 40% alc.",
                    gramaj: "40 ml",
                    price: 30,
                },
                {
                    name_ro: "EL JIMADOR",
                    desc_ro: "Blanco / Reposado 100% Agave 38% alc.",
                    gramaj: "40 ml",
                    price: 25,
                },
                {
                    name_ro: "PEPE LOPEZ",
                    desc_ro: "Blanco / Gold 40% alc. ",
                    gramaj: "40 ml",
                    price: 10,
                },
                {
                    name_ro: "CAMINO REAL",
                    desc_ro: "Blanco / Gold 40% alc. ",
                    gramaj: "40 ml",
                    price: 10,
                },
                {
                    name_ro: "BACARDI",
                    desc_ro: "Superior / Premium Black / Gold / Oakheart 37.5% alc",
                    gramaj: "40 ml",
                    price: 12,
                },
            ]
        },
        {
            id: "sambuca",
            name_ro: "SAMBUCA, MASTICA & OUZO",
            desc_ro: "",
            name_eng: "SAMBUCA, MASTICA & OUZO ",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "VACCARI",
                    desc_ro: "Sambuca Clasic / Nero 38% alc.",
                    gramaj: "40 ml",
                    price: 10,
                },
                {
                    name_ro: "SKINOS",
                    desc_ro: "Mastiha 30% alc. ",
                    gramaj: "40 ml",
                    price: 14,
                },
                {
                    name_ro: "OUZO",
                    desc_ro: "Plomari 40% alc. ",
                    gramaj: "40 ml",
                    price: 10,
                },
            ]
        },
        {
            id: "lichioruri",
            name_ro: "LICHIORURI ",
            desc_ro: "",
            name_eng: "LIQUEURS",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "SOUTHERN COMFORT ",
                    desc_ro: "35% alc. ",
                    gramaj: "40 ml",
                    price: 12,
                },
                {
                    name_ro: "CHAMBORD",
                    desc_ro: "16.5% alc. ",
                    gramaj: "40 ml",
                    price: 18,
                },
                {
                    name_ro: "COINTREAU",
                    desc_ro: "40% alc.",
                    gramaj: "40 ml",
                    price: 14,
                },
                {
                    name_ro: "PASSOA",
                    desc_ro: "17% alc.",
                    gramaj: "40 ml",
                    price: 11,
                },
                {
                    name_ro: "BAILEY'S",
                    desc_ro: "15% alc.",
                    gramaj: "40 ml",
                    price: 12,
                },
                {
                    name_ro: "JÄGERMEISTER",
                    desc_ro: "Ice Cold Shot 20 ml 35% alc.",
                    gramaj: "40 ml",
                    price: 5,
                },
                {
                    name_ro: "VISINATA",
                    desc_ro: "30% alc.",
                    gramaj: "40 ml",
                    price: 12,
                },
                {
                    name_ro: "AFINATA",
                    desc_ro: "30% alc.",
                    gramaj: "40 ml",
                    price: 12,
                },
            ]
        },
        {
            id: "vermouth si bitter",
            name_ro: "",
            desc_ro: "",
            name_eng: "VERMOUTH & BITTERS ",
            gramaj_st: "40 ml",
            prod: [
                {
                    name_ro: "MARTINI",
                    desc_ro: "Bianco / Rosso / Rosato / extra dry, 15% alc. ",
                    gramaj: "40 ml",
                    price: 10,
                },
                {
                    name_ro: "MARTINI",
                    desc_ro: "Bitter 25% alc.",
                    gramaj: "40 ml",
                    price: 10,
                },
                {
                    name_ro: "MAMAIA",
                    desc_ro: "Aperitiv",
                    gramaj: "40 ml",
                    price: 6,
                },
            ]
        },
        {
            id: "ceasi si cafea",
            name_ro: "CAFEA SI CEAI",
            desc_ro: "",
            name_eng: "COFFEE & TEA",
            gramaj_st: "",
            prod: [
                {
                    name_ro: "Espresso",
                    price: 10,
                },
                {
                    name_ro: "Cappuccino",
                    price: 13,
                },
                {
                    name_ro: "Caffe Latte",
                    price: 14,
                },
                {
                    name_ro: "Revolution Hot Tea",
                    price: 12,
                },
            ]
        },
        {
            id: "bere si licori slabe",
            name_ro: "BERE SI LICORI SLABE",
            desc_ro: "",
            name_eng: "BEERS & RTD'S",
            gramaj_st: "",
            prod: [
                {
                    name_ro: "CRAMA DOMNEASCA",
                    desc_ro: "Draught ",
                    gramaj: "400 ml",
                    price: 9,
                },
                {
                    name_ro: "STELLA ARTOIS",
                    desc_ro: "Draught, 5% alc.",
                    gramaj: "250 ml",
                    price: 8,
                },
                {
                    name_ro: "STELLA ARTOIS",
                    desc_ro: "Draught, 5% alc.",
                    gramaj: "400 ml",
                    price: 10,
                },
                {
                    name_ro: "STELLA ARTOIS ",
                    desc_ro: "5% alc. ",
                    gramaj: "500 ml",
                    price: 12,
                },
                {
                    name_ro: "BECK'S",
                    desc_ro: "5% alc. ",
                    gramaj: "500 ml",
                    price: 11,
                },
                {
                    name_ro: "FRANZISKANER ",
                    desc_ro: "Blonda Nefiltrata, 5.0% alc. ",
                    gramaj: "500 ml",
                    price: 20,
                },
                {
                    name_ro: "FRANZISKANER",
                    desc_ro: "Neagra Nefiltrata 5.0% alc. ",
                    gramaj: "500 ml",
                    price: 20,
                },
                {
                    name_ro: "MILLER ",
                    desc_ro: "4.7% alc. ",
                    gramaj: "330 ml",
                    price: 13,
                },
                {
                    name_ro: "CORONA",
                    desc_ro: "Extra, 4.5% alc.",
                    gramaj: "355 ml",
                    price: 14,
                },
                {
                    name_ro: "HOEGAARDEN",
                    desc_ro: "White Nefiltrata, 4.9% alc. ",
                    gramaj: "330 ml",
                    price: 16,
                },
                {
                    name_ro: "LEFFE",
                    desc_ro: "Blond, 6.6% alc. ",
                    gramaj: "330 ml",
                    price: 20,
                },
                {
                    name_ro: "LEFFE",
                    desc_ro: "Brun, 6.5% alc. ",
                    gramaj: "330 ml",
                    price: 20,
                },
                {
                    name_ro: "LEFFE",
                    desc_ro: "Ruby, 5% alc. ",
                    gramaj: "330 ml",
                    price: 20,
                },
                {
                    name_ro: "LEFFE",
                    desc_ro: "Radieuse, 8.2% alc. ",
                    gramaj: "330 ml",
                    price: 20,
                },
                {
                    name_ro: "STAROPRAMEN ",
                    desc_ro: "Dark, 4.4% alc.",
                    gramaj: "330 ml",
                    price: 11,
                },
                {
                    name_ro: "STAROPRAMEN ",
                    desc_ro: "Nefiltrat, 4% alc.",
                    gramaj: "330 ml",
                    price: 11,
                },
                {
                    name_ro: "STAROPRAMEN ",
                    desc_ro: "Granat, 4.8% alc.",
                    gramaj: "330 ml",
                    price: 11,
                },
                {
                    name_ro: "STELLA ARTOIS ",
                    desc_ro: "Cidre, 4.5% alc.",
                    gramaj: "500 ml",
                    price: 20,
                },
                {
                    name_ro: "STELLA ARTOIS ",
                    desc_ro: "N.A.",
                    gramaj: "500 ml",
                    price: 12,
                },
            ]
        },
        {
            id: "energizante",
            name_ro: "ENERGIZANTE",
            desc_ro: "",
            name_eng: "ENERGY DRINKS",
            gramaj_st: "",
            prod: [
                    {
                    name_ro: "RED BULL",
                    desc_ro: "",
                    gramaj: "250 ml",
                    price: 10,
                    },
                    {
                    name_ro: "RED BULL SUGAR FREE",
                    desc_ro: "",
                    gramaj: "250 ml",
                    price: 10,
                    },
                    {
                    name_ro: "RED BULL TROPICAL",
                    desc_ro: "",
                    gramaj: "250 ml",
                    price: 10,
                    },
                    {
                    name_ro: "RED BULL COCOS",
                    desc_ro: "",
                    gramaj: "250 ml",
                    price: 10,
                    },
                ]
        },
        {
            id: "racoritoare",
            name_ro: "RACORITOARE",
            desc_ro: "",
            name_eng: "WATER & SOFT DRINKS",
            gramaj_st: "",
            prod: [
                {
                    name_ro: "EVIAN",
                    desc_ro: "",
                    gramaj: "330 ml glass",
                    price: 12,
                },
                {
                    name_ro: "EVIAN",
                    desc_ro: "",
                    gramaj: "1 L PET",
                    price: 22,
                },
                {
                    name_ro: "BADOIT ROUGE ",
                    desc_ro: "",
                    gramaj: "330 ml glass",
                    price: 12,
                },
                {
                    name_ro: "BADOIT ROUGE ",
                    desc_ro: "",
                    gramaj: "1000 ml PET",
                    price: 22,
                },
                {
                    name_ro: "BUCOVINA",
                    desc_ro: "Plata / Carbogazoasa",
                    gramaj: "750 ml glass",
                    price: 12,
                },
                {
                    name_ro: "OCEAN SPRAY",
                    desc_ro: "Cranberry Juice",
                    gramaj: "1 L",
                    price: 20,
                },
                {
                    name_ro: "ARIZONA",
                    desc_ro: "Ice Tea Blueberry / White / Green / Lemon / Peach / Pomegranate ",
                    gramaj: "",
                    price: 20,
                },
                {
                    name_ro: "Limonada Crama Domneasca ",
                    desc_ro: "",
                    gramaj: "1 L",
                    price: 42,
                },
                {
                    name_ro: "PEPSI / 7UP / MIRINDA / EVERVESS ",
                    desc_ro: "",
                    gramaj: "250 ml",
                    price: 9,
                },
                {
                    name_ro: "PRIGAT",
                    desc_ro: "Suc Natural",
                    gramaj: "250 ml",
                    price: 9,
                },
                {
                    name_ro: "TRUE",
                    desc_ro: "Energy / Ginger / Tonic ",
                    gramaj: "",
                    price: 10,
                },
                {
                    name_ro: "GRANINI",
                    desc_ro: "Orange / Apple / Peach",
                    gramaj: "250 ml",
                    price: 9,
                },
                {
                    name_ro: "LIPTON ",
                    desc_ro: "Ice Tea Lemon / Peach / Green Tea ",
                    gramaj: "250 ml",
                    price: 9,
                },
            ]
        },
        {
            id: "tigari winston",
            name_ro: "",
            desc_ro: "www.yourfreedom.ro",
            name_eng: "PREMIUM CIGARETTES - WINSTON",
            prod: [
                {
                    name_ro: "WINSTON",
                    desc_ro: "XSTYLE (BLUE - 6 MG, SILVER - 4 MG)",
                },
                {
                    name_ro: "WINSTON",
                    desc_ro: "PLUS (RED - 10 MG)",
                },
                {
                    name_ro: "WINSTON",
                    desc_ro: "XSPRESSION (6 MG)",
                },
                {
                    name_ro: "WINSTON",
                    desc_ro: "XSPRESSION SUPER LINE (5 MG)",
                },
                {
                    name_ro: "WINSTON",
                    desc_ro: "NOVA (BLUE LONGS - 8 MG)",
                },
                {
                    name_ro: "WINSTON",
                    desc_ro: "SUPER LINE (BLUE - 5 MG, SILVER - 3 MG)",
                },
                {
                    name_ro: "WINSTON",
                    desc_ro: "(CLASSIC LONGS - 10 MG, BLUE LONGS - 6 MG, BLUE - 6 MG, SILVER - 4 MG)",
                },
            ]
        },
        {
            id: "tigari sobranie",
            name_ro: "PREMIUM CIGARETTES - SOBRANIE",
            desc_ro: "www.yoursociety.ro",
            name_eng: "",
            prod: [
                {
                    name_ro: "SOBRANIE ",
                    desc_ro: "REDEFINED (BLACK - 6 MG, BLUE - 5 MG, CHROME - 4 MG, WHITE - 1 MG)",
                },
                {
                    name_ro: "SOBRANIE ",
                    desc_ro: "SUPER S (BLACK - 6 MG, PINK - 3 MG, WHITE - 1 MG)",
                },
                {
                    name_ro: "SOBRANIE ",
                    desc_ro: "COLLECTION (BLACKS - 6 MG, GOLDS - 3 MG)",
                },
                {
                    name_ro: "SOBRANIE ",
                    desc_ro: "EVOLVE (BLACK - 6 MG, CHROME - 4 MG)",
                },
                {
                    name_ro: "SOBRANIE ",
                    desc_ro: "KING SIZE (BLACK - 7 MG, GOLD - 3 MG)",
                },

            ]
        },
        {
            id: "tigari camel",
            name_ro: "PREMIUM CIGARETTES - CAMEL",
            desc_ro: "",
            name_eng: "",
            prod: [
                {
                    name_ro: "CAMEL",
                    desc_ro: "YELLOW - 10 MG",
                },
            ]
        },

    ]
}